import { Shield, Award, Users, TrendingUp } from "lucide-react";

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left content */}
          <div>
            <div className="inline-block bg-emerald-50 rounded-full px-6 py-2 mb-6">
              <span className="text-emerald-700 font-semibold text-sm tracking-wide">ABOUT US</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              Leading Property Registration Experts in 
              <span className="text-emerald-700"> Bengaluru</span>
            </h2>
            
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              With over <span className="font-bold text-slate-900">20 years of excellence</span>, CHAITRA ENTERPRISES has established itself as the most trusted name in property registration and legal documentation services in Bengaluru.
            </p>
            
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              We specialize in providing comprehensive property registration services for sites, plots, and apartments, along with expert legal consultancy. Our commitment to transparency, accuracy, and client satisfaction has made us the preferred choice for thousands of property owners and investors.
            </p>

            {/* Key highlights */}
            <div className="grid grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="bg-emerald-100 rounded-lg p-3">
                  <Shield className="text-emerald-700" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900 mb-1">100% Legal Compliance</h4>
                  <p className="text-sm text-slate-600">Guaranteed accuracy</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-amber-100 rounded-lg p-3">
                  <Award className="text-amber-600" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900 mb-1">Expert Team</h4>
                  <p className="text-sm text-slate-600">Seasoned professionals</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-blue-100 rounded-lg p-3">
                  <Users className="text-blue-700" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900 mb-1">Client-Focused</h4>
                  <p className="text-sm text-slate-600">Your trust matters</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-purple-100 rounded-lg p-3">
                  <TrendingUp className="text-purple-700" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900 mb-1">Fast Processing</h4>
                  <p className="text-sm text-slate-600">Quick turnaround</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzcyNDQwODc1fDA&ixlib=rb-4.1.0&q=85" 
                alt="Modern professional office"
                className="w-full h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
            </div>
            
            {/* Floating card */}
            <div className="absolute -bottom-8 -left-8 bg-white rounded-xl shadow-2xl p-6 max-w-xs">
              <div className="flex items-center gap-4 mb-3">
                <div className="bg-gradient-to-br from-emerald-500 to-emerald-700 rounded-full p-3">
                  <Shield className="text-white" size={24} />
                </div>
                <div>
                  <div className="text-2xl font-bold text-slate-900">20+</div>
                  <div className="text-sm text-slate-600">Years of Trust</div>
                </div>
              </div>
              <p className="text-sm text-slate-600">
                Delivering excellence in property registration and legal documentation since 2004
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
